import script from "./QuarterGames.vue?vue&type=script&setup=true&lang=js"
export * from "./QuarterGames.vue?vue&type=script&setup=true&lang=js"

import "./QuarterGames.vue?vue&type=style&index=0&id=76e83cf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e83cf8"]])

export default __exports__